/**
 * Created by why on 2019/10/21.
 */
import {
  getByCondition,
  delByIds
} from '@/api/log-manage'

export default {
  state: {
    list: [],
    loading: false,
    pageSize: 10,
    pageNum: 1,
    total: 0
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setLogLoading (state, loading) {
      state.loading = loading
    },
    setPageSize (state, pageSize) {
      state.pageSize = pageSize
    },
    setPageNum (state, pageNum) {
      state.pageNum = pageNum
    },
    setTotal (state, total) {
      state.total = total
    }
  },
  getters: {
    logList: state => state.list,
    logLoading: state => state.loading,
    logTotal: state => state.total
  },
  actions: {
    getLogByCondition ({ state, commit }, data) {
      commit('setLogLoading', true)
      return new Promise((resolve, reject) => {
        getByCondition(data).then(res => {
          const data = res.data.result
          const list = data.records
          const pageSize = data.pageSize
          const pageNum = data.pageNum
          const total = data.total
          commit('setList', list)
          commit('setLogLoading', false)
          commit('setPageSize', pageSize)
          commit('setPageNum', pageNum)
          commit('setTotal', total)
          resolve(res)
        }).catch(err => {
          commit('setLogLoading', false)
          reject(err)
        })
      })
    },
    getLogDelByIds ({ state, commit }, ids) {
      return new Promise((resolve, reject) => {
        delByIds(ids).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/log-manage.js